import cookies from 'js-cookie';

const initialize = () => {
    document.addEventListener("DOMContentLoaded", function(){
        let anchors = document.getElementsByTagName('a');

        for (var i = 0; i < anchors.length; i++) {
            anchors[i].addEventListener('click', (e) => {
                e.preventDefault();

                if (!e.currentTarget.classList.contains('not-link-handler')) {
                    cookies.set(
                        window.euPortalConfig.stay_on_page_cookie_name,
                        true,
                        { path: '/', domain: '.' + window.euPortalConfig.domain }
                    );
                }

                window.location = e.currentTarget.href;
            });
        }
    });
};

export default initialize;
